import { BoxProps, IconButton, Input, useToast } from "@chakra-ui/react";
import React from "react";
import { FaUpload } from "react-icons/fa";

interface Props extends BoxProps {
  isDisabled?: boolean;
  accept?: string;
  onFileChange: (value: File) => void;
  file: File | undefined;
  setFile: any;
  inputRef: any;
  isLoading: boolean;
}

export default function UploadButton({
  isDisabled,
  isLoading,
  accept,
  onFileChange,
  file,
  setFile,
  inputRef,
  ...rest
}: Props) {
  const toast = useToast();
  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const fsize = e?.currentTarget?.files
      ? e?.currentTarget?.files[0]?.size
      : 0;
    const fileSizeInMb = Math.round(fsize / 1024);
    if (
      e?.currentTarget?.files &&
      accept?.includes(e?.currentTarget?.files[0]?.type) &&
      fileSizeInMb < 51200
    ) {
      onFileChange(Object(e.currentTarget.files)[0]);
      setFile(Object(e.currentTarget.files)[0]);
    } else {
      toast({
        title: "Arquivo inválido",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      e.currentTarget.files = null;
      onFileChange(Object({})[0]);
      setFile(Object({})[0]);
    }
  }
  const handleDeleteFile = () => {
    if (inputRef?.current?.value) {
      inputRef.current.value = "";
    }
    onFileChange(Object({})[0]);
    setFile(Object({})[0]);
  };
  return (
    <>
      <IconButton
        isDisabled={isDisabled}
        // backgroundColor="var(--icon-color)"
        // color="white"
        aria-label="Salvar"
        icon={<FaUpload />}
        isLoading={isLoading}
      />

      <Input
        isDisabled={isDisabled}
        ref={inputRef}
        pl="120%"
        opacity="0"
        type="file"
        accept={accept}
        position="absolute"
        onChange={handleFileChange}
        w="100%"
        h="100%"
        cursor="pointer"
      />
    </>
  );
}
